import { render } from "./LeagueSubNavigation.vue?vue&type=template&id=b89f597c"
import script from "./LeagueSubNavigation.vue?vue&type=script&lang=js"
export * from "./LeagueSubNavigation.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__